module.exports = __webpack_public_path__ + "static/media/p5.85d0d670.jpeg";